import { render, staticRenderFns } from "./TenderCardSkeleton.vue?vue&type=template&id=3a7daaa2&scoped=true&"
import script from "./TenderCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./TenderCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./TenderCardSkeleton.vue?vue&type=style&index=0&id=3a7daaa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7daaa2",
  null
  
)

export default component.exports